<div class='logo-container'>
  <img class='logo' src='assets/logo-dark.svg' alt='Logo' />
  <span>SAGT</span>
</div>

<button mat-raised-button (click)="login()" color="accent">S'identifier</button>